import React, {Component} from 'react';
import { Subscribe } from 'unstated';
import DataContainer from './data/data';

class Divisions extends Component {
    render () {
        return (
            <Subscribe to={[DataContainer]}>
                {(DataContainer) => {
                    const divs = DataContainer.getDivisions();
                    const tr = divs[0];
                    const br = divs[1];
                    const bl = divs[2];
                    const tl = divs[3];

                    return (
                        <div className="divisions">
                            <div className="division-row">
                                <div className="division-col">
                                    {tl}
                                </div>
                                <div className="division-col">
                                    {tr}
                                </div>
                            </div>
                            <div className="division-row right">
                                <div className="division-col">
                                    {bl}
                                </div>
                                <div className="division-col">
                                    {br}
                                </div>
                            </div>
                        </div>
                    );
                }}
            </Subscribe>
        );
    }
}

export default Divisions;